<template>
    <div class="touch-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="box _gradient-bar">
            <div class="box-1">
                <h1>
                    Helping installers sell more easily in the modern world.
                </h1>
                <p>
                    A user-friendly software tool which simplifies quoting and ordering online and helps you win more business.
                </p>
                <a class="btn-primary" @click="enquiry_box_open = true">
                    Make Enquiry
                </a>
                <div class="image">
                    <img src="/images/touch-page-image-1.png">
                </div>
            </div>
            <div class="box-2">
                <div class="content _primary align-center">
                    <h1>
                        Generate more enquiries and
                        sales with Vendor. Available in 2 Modes.
                    </h1>
                    <p>
                        Recognising the two main routes to your sales are direct and online,
                        Vendor provides you with two distinct modes to cater for these.
                    </p>
                    <div class="cols">
                        <div class="col">
                            <div class="image">
                                <img src="/images/touch-page-image-2.png">
                            </div>
                            <div>
                                Lead Generation
                            </div>
                            <div>
                                Website Tool
                            </div>
                        </div>
                        <div class="col">
                            <div class="image">
                                <img src="/images/touch-page-image-3.png">
                            </div>
                            <div>
                                Quote and Survey
                            </div>
                            <div>
                                Field and Showroom Tool
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-3">
                <h1>
                    Maximise sales by using Vendor
                    across your whole business.
                </h1>
                <div class="panels">
                    <div class="panel">
                        <div class="image">
                            <img src="/images/touch-page-image-4.png">
                        </div>
                      <div class="content">
                        <p>
                          <strong>Website Lead Generation</strong>
                        </p>
                        <p>
                          In consumer mode, Vendor allows you to capture warm sales leads online. Homeowners design their doors and windows via the tool on your website and the enquiries can be instantly converted into quotes and priced up automatically with no re-processing. There is also an option to add in live pricing.
                        </p>
                      </div>
                    </div>
                    <div class="panel">
                        <div class="image">
                            <img src="/images/touch-page-image-5.png">
                        </div>
                      <div class="content">
                        <p>
                          <strong>Field Quote & Survey Tool</strong>
                        </p>
                        <p>
                          Armed with their own Vendor log-in, sales staff can craft a quote for a consumer in real time during the sales visit. Combined with the Virtual Home visualiser, it provides a unique selling experience and gives even the smallest business an impressive, professional edge.
                        </p>
                      </div>
                    </div>
                    <div class="panel">
                        <div class="image">
                            <img src="/images/touch-page-image-6.png">
                        </div>
                      <div class="content">
                        <p>
                          <strong>Remote Virtual Selling</strong>
                        </p>
                        <p>
                          Vendor is the ideal tool for online sales presentations, allowing for shared quote generation and online home visualisations to enhance the customer experience.
                        </p>
                      </div>
                    </div>
                </div>
            </div>
            <div class="box-4">
                <div class="col-info">
                    <div>
                        <h1>
                            Real-time pricing
                            as standard.
                        </h1>
                        <p>
                            <strong>
                                Quote and survey designer
                            </strong>
                        </p>
                        <p>
                            Once prices are configured your live selling price will be visible as you build a quote. You can also view a breakdown of your configured price to check your prices are profitable.
                        </p>
                        <p>
                            <strong>
                                Lead generation designer
                            </strong>
                        </p>
                        <p>
                            Using the same pricing setup any enquiries made by a homeowner will land in your account with your selling price pre-calculated. You also have the option to turn this on or off for homeowners live to live price
                        </p>
                    </div>
                </div>
                <div class="col-image">
                    <img src="/images/touch-page-image-7.png">
                </div>
            </div>
            <div class="box-5">
                <div class="col-info">
                    <div>
                        <h1>
                            Brand Vendor with your
                            logo and contact details.
                        </h1>
                        <p>
                            Give your organisation a big company image by utilising Vendor in consumer mode. Any visitors see your company name, logo and contact details accessing the system. Designed to be consumer friendly, the visitor is guided through the design process step-by-step. Any sales leads captured are available to your sales staff through the Vendor portal.
                        </p>
                    </div>
                </div>
                <div class="col-image">
                    <img src="/images/touch-page-image-8.png">
                </div>
            </div>
            <div class="download-vendor-guide">
                <div class="col-info">
                    <div>
                        <h1>
                            Download Vendor Guide
                        </h1>
                        <p>
                            For more information on TOUCH Vendor please download a complete guide.
                        </p>
                        <a class="btn-primary-outline" href="/documents/vendor_how_to_guide.pdf" target="_blank">
                           Download
                        </a>
                    </div>
                </div>
                <div class="col-guide">
                    <a href="/documents/vendor_how_to_guide.pdf" target="_blank">
                        <img src="/images/touch-page-image-9.png">
                    </a>
                </div>
            </div>
            <div class="support-box">
                <div class="cols">
                    <div class="col-info">
                        <h1>Vendor Support</h1>
                        <p>
                            Dont worry if you are not tech savy, Vendor is designed to be easy to purchase and setup in just a few minutes. We can also work alongside you to help with setup.
                        </p>
                        <p>
                            Call us now for more information on 01429 239 689
                        </p>
                        <p>
                            <a class="btn-primary-outline" @click="enquiry_box_open = true">
                                Make an enquiry
                            </a>
                        </p>
                    </div>
                    <div class="col-image">
                        <img src="/images/website-support-box-image.png">
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Thank you for your interest</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Your enquiry will be sent to our team who will aim to respond within 48 hours, you will be sent
                        a notification when you receive a reply.
                    </div>
                    <div class="mb-6">
                        If you would like to provide some more information you can edit the message below.
                    </div>
                    <strong class="block pl-2 pb-1">Your Message</strong>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'system_types',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I am interested in purchasing Touch Vendor, could I be sent some further information, thank you.',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 28,
                'message': this.enquiry_message,
            })
                .then((response) => {

                  gtag('event', 'enquiry_made', {
                    'event_category': 'enquiries',
                    'event_label': 'Touch enquiry',
                    'value': 'Touch enquiry',
                  });

                    this.sending = false;
                    Swal.fire({
                        title: 'Enquiry Sent',
                        icon: 'success',
                        text: 'Your Enquiry has been sent, you will be sent a notification when you receive a reply.'
                    });
                });
        },
    },
};
</script>
